export default "__VITE_ASSET__BHA66aZx__"